import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const VocabularyFormSlice = createSlice({
  name: "VocabularyForm",
  initialState,
  reducers: {
    getVocabularyForm: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { getVocabularyForm } = VocabularyFormSlice.actions;

export default VocabularyFormSlice.reducer;
